import { CustomerDataResponseV1 } from 'shared/services/api/models/customerData'
import { LetterboxDocumentV1 } from 'shared/services/api/models/letterbox'

export enum EXTERNAL_SHIPMENT_SERVICE {
  PARCELLAB = 'parcellab'
}
export interface OrderDiscountV1 {
  amount: number
  discountId: string
  displayName: string
}

export interface OrderBillingAddressV1 {
  city: string
  countryCode: string
  doorCode: string
  extension: string
  id: string
  street: string
  streetNo: string
  type: string
  zip: string
}

export interface OrderPickupStationV1 {
  id: string
  name: string
  postNumber: string
  type: string
}

export interface ExternalCarriersIdsV1 {
  [EXTERNAL_SHIPMENT_SERVICE.PARCELLAB]: string
}
export interface OrderCarrierV1 {
  costs: number
  externalCarrierIds: ExternalCarriersIdsV1
  displayName: string
  identifier: string
  trackingId: string
}

export interface OrderPaymentV1 {
  paymentKind: string
  paymentProviderTransactionId: string
  paymentStatus: string
}

export interface OrderMasterDataV1 {
  currency: string
  language: string
  orderDate: string
  orderNumber: string
  prescriptionFollows: boolean
  totalAmount: number
  totalAmountDiscountRedpoints: number
  totalAmountDiscounts: number
  totalAmountDiscountVoucher: number
  totalAmountDocuments: number
  totalAmountPrescriptionBonus: number
  totalAmountPrescriptionBonusDiscount: number
  totalAmountPrescriptionBonusToAccount: number
  totalAmountRedeemedRedpoints: number
  totalAmountRedpoints: number
  totalAmountShippingCost: number
}

export interface OrderDocumentPricePerUnitV1 {
  formatted: string
}

export interface OrderDeliveryAddressV1 {
  city: string
  countryCode: string
  doorCode: string
  extension: string
  firstName: string
  id: string
  lastName: string
  pickupStation: OrderPickupStationV1
  salutation: string
  street: string
  streetNo: string
  type: string
  zip: string
}

export interface OrderDocumentPositionV1 {
  amountRedpoints: number
  availability: string
  canonicalURL: string
  isCoolingRequired: boolean
  itemName: string
  itemTax: number
  lineAmount: number
  lineDiscountPercent: number
  lineNum: number
  packagingQuantity: number
  packagingUnit: string
  pharmaForm: string
  prescriptionBonus: number
  pricePerUnit: OrderDocumentPricePerUnitV1
  pzn: string
  quantity: number
  salesPrice: number
  thumbnailURL: string
  upid: string
}

export interface OrderDocumentsV1 {
  documentPositions: OrderDocumentPositionV1[]
  type: string
}

export interface SuborderV1 {
  billingAddress: OrderBillingAddressV1
  carrier: OrderCarrierV1
  deliveryAddress: OrderDeliveryAddressV1
  discounts: OrderDiscountV1[]
  documentsToDownload: LetterboxDocumentV1[]
  orderDocuments: OrderDocumentsV1[]
  orderType: string
  payment: OrderPaymentV1
  sellerId: string
  sellerName: string
  shippedDate: string
  status: string
  subOrderId: string
  totalAmount: number
  totalAmountDocuments: number
  totalAmountPrescriptionBonus: number
  totalAmountRedpoints: number
}

export interface OrderResponseV1 {
  customerMasterData: CustomerDataResponseV1
  orderMasterData: OrderMasterDataV1
  subOrders: SuborderV1[]
}

export interface OrdersResponseV1 {
  itemsPerPage: number
  orders: OrderResponseV1[]
  page: number
  totalItems: number
  totalPages: number
}
